import React, { useState, useEffect } from "react";
import Header from "../../Header";
import { Link } from "react-router-dom";
import Footer from "../../Footer";
import {
  // MNG_TOKEN,
  // MMFX_TOKEN_ADDRESS,
  // ORACLE_MNG,
  // MMUSD_TOKEN_ADDRESS,
  // MMOX_ADDRESS,
  POTION_DAO_STAKING_ADDRESS,
  WETHX_PTN_POOL_ADDRESS,
  PTN_TOKEN_ADDRESS,
  WETHX_PTN_MASTER_ORACLE_ADDRESS,
  WETHX_WETH_ORACLE_ADDRESS,
  POTION_DAO_CHEF_ADDRESS,
  POTION_DAO_ZAP_ADDRESS,
  WETHX_TOKEN_ADDRESS,
  EX_LINK,
  UNISWAP_ROUTER_ADDRESS,
  WETH_TOKEN_ADDRESS,
  BNBX_BNB_LP,
  SHLD_BNB_LP,
  BNB_ORACLE,
  BNB_GUARD_ORACLE,
  GUARD,
  GUARDX,
  GUARD_GUARDX_LP,
  BNBX_GUARDX_LP,
  ANDYX,
  ANDY,
  ANDY_BNB_ORACLE,
  ANDY_ANDYX_ORACLE,
  ANDY_ANDYX_LP,
} from "../../../Config/index";
// import MNG_TOKEN_ABI from "../../../Config/MNG_TOKEN_ABI.json";
// import ORACLE_MNG_MMF from "../../../Config/ORACLE_MNG_MMF.json";
// import MMFX_TOKEN from "../../../Config/MMFX_TOKEN.json";
// import MMUSD_TOKEN from "../../../Config/MMUSD_TOKEN.json";
// import MMOX_TOKEN from "../../../Config/MMOX_TOKEN.json";
import POTION_DAO_STAKING_ABI from "../../../Config/POTION_DAO_STAKING_ABI.json";
import TOKEN_ABI from "../../../Config/TOKEN_ABI.json";

import IUniswapv2Pair from "../../../Config/IUniswapv2Pair.json";
import IUniswapOracle from "../../../Config/IUniswapOracle.json";
import IUniswapOracleV3 from "../../../Config/IUniswapOracleV3.json";

import BNBORACLEABI from "../../../Config/BNBORACLE.json";

import UniswapRouter from "../../../Config/UniswapRouter.json";
import WETHX_PTN_POOL_ABI from "../../../Config/WETHX_PTN_POOL_ABI.json";
import WETHX_PTN_MASTER_ORACLE_ABI from "../../../Config/WETHX_PTN_MASTER_ORACLE_ABI.json";
import WETHX_WETH_ORACLE_ABI from "../../../Config/WETHX_WETH_ORACLE_ABI.json";
import POTION_DAO_CHEF_ABI from "../../../Config/POTION_DAO_CHEF_ABI.json";
import POTION_DAO_ZAP_ABI from "../../../Config/POTION_DAO_ZAP_ABI.json";
import { useAccount, useBalance, useContractRead, useToken } from "wagmi";
import { useNavigate } from "react-router-dom";
import { Avatar, AvatarGroup, Grid } from "@mui/material";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";
import convertWeiToEther from "../../../Utils/convertWeiToEther";
import Loader from "../../Loader/Loader";
import styles from "./home.module.css";
import convertEtherToWei from "../../../Utils/convertEtherToWei";
import { Hero } from "./Hero";
import { Navbar } from "../../Navbar";
import AddIcon from "@mui/icons-material/Add";
import { formatNumber } from "../../common/FormateNum";
import { ethers } from "ethers";
import BigNumber from "bignumber.js";
import { NewFooter } from "../../NewFooter";

export default function Home() {
  const navigate = useNavigate();
  const [poolArray, setPoolArray] = useState([]);
  const [potionPrice, setPotionPrice] = useState(0);
  const [selectedToken, setSelectedToken] = useState("BNBX");
  const [selectedTokenIcon, setSelectedTokenIcon] = useState("");

  const [selectedTokenPrice, setSelectedTokenPrice] = useState(0);

  const [tokenMenu, setTokenMenu] = useState(false);

  // const potionPrice =0.0006358; // $ hard coded value
  let alienPrice = 0;
  const alienxPrice = 545;

  const { data: _alienPrice } = useCustomContractRead({
    Adrress: BNB_ORACLE,
    Abi: BNBORACLEABI,
    FuncName: "latestAnswer",
    // onSuccess:(data)=>{
    //   alienPrice = ethers.utils.formatUnits(data, 8);
    // }
  });

  alienPrice = _alienPrice ? ethers.utils.formatUnits(_alienPrice, 8) : 1;
  // console.log("alienPrice", alienPrice);

  const { data: _rewardData } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    Args: [PTN_TOKEN_ADDRESS],
    FuncName: "rewardData",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const [bnbXPrice, setbnbXPrice] = useState(0);
  const { data: reserves } = useCustomContractRead({
    Adrress: BNBX_BNB_LP,
    Abi: IUniswapv2Pair,
    FuncName: "getReserves",
    isEnabled: SHLD_BNB_LP !== undefined,
    onSuccess: (data) => {
      let _wethx = Number(data[1]);
      let _weth = Number(data[0]) * Number(alienPrice);
      let _price = Number(_weth) / Number(_wethx);
      setbnbXPrice(_price);
    },
  });
  useEffect(() => {
    if (reserves && alienPrice) {
      let _wethx = Number(reserves[1]);
      let _weth = Number(reserves[0]) * Number(alienPrice);
      let _price = Number(_weth) / Number(_wethx);
      if (!Number(_price)) {
        setbnbXPrice(0);
      } else {
        setbnbXPrice(_price);
      }
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [reserves, alienPrice]);

  const { data: _rewardDataStake } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    Args: [WETH_TOKEN_ADDRESS],
    FuncName: "rewardData",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const { data: _rewardDataLocked } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    Args: [WETHX_TOKEN_ADDRESS],
    FuncName: "rewardData",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const { data: _rewardsDuration } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "rewardsDuration",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const getLockerApr = () => {
    // const rewardRate = convertWeiToEther(_rewardData?.[1]);
    // let _potionPrice = Number(potionPrice) ? Number(potionPrice) : 0;

    // const rewardLockedRate = convertWeiToEther(_rewardDataLocked?.[1]);
    // const rewardDuration = _rewardsDuration || 0
    // const amountA = Number(rewardRate) * Number(rewardDuration);
    // const amountB = Number(rewardLockedRate) * Number(rewardDuration);
    // const valueA =  Number(amountA) * Number(_potionPrice);
    // const valueB = amountB * Number(_potionPrice);
    // // const amoundD = lockedBalances ;
    // const valueD = 100 * _potionPrice;

    // // //console.log(_rateA);
    // // //console.log(_rateB);
    // const days = Number(rewardDuration) / 86400;
    // // console.log("rewardRate", days);
    // // const amount = 100 ;
    // // //console.log((valueA+valueB/valueD)*(365/(days*4))*100);
    // // return 0;
    // return (valueA + valueB / valueD) * (365 / (days * 4)) * 100;
    return getApr() * 2;
  };

  const { data: totalStakedSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "totalSupply",
    // onSuccess:(data)=>{
    //   //console.log(data?.toString());
    // }
  });

  const getApr = () => {
    const rewardRate = convertWeiToEther(_rewardDataStake?.[1]);
    const rewardDuration = Number(_rewardsDuration) || 0;
    const days = rewardDuration / 86400;
    const amount = convertWeiToEther(totalStakedSupply) * potionPrice;
    const rewardInUsd = Number(rewardRate) * Number(alienPrice);
    return ((rewardInUsd * rewardDuration) / amount) * (365 / days) * 100;
  };
  // console.log("getApr", getLockerApr());

  const addTokenInMetaMask = (tokenSymbol, tokenAddress, tokenIcon) => {
    window.ethereum
      .request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: 18,
            image: tokenIcon,
          },
        },
      })
      .then((success) => {
        if (success) {
          //console.log("FOO successfully added to wallet!");
        } else {
          throw new Error("Something went wrong.");
        }
      })
      .catch(console.error);
  };

  const { data: totalSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "totalSupply",
  });

  const { data: totalLockedSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "lockedSupply",
    // onSuccess:(data)=>{
    //   console.log(data?.toString());
    // }
  });

  const { data: minatiTokenInfo } = useToken({
    address: PTN_TOKEN_ADDRESS,
  });
  const { data: alienxTokenInfo } = useToken({
    address: WETHX_TOKEN_ADDRESS,
  });

  const { data: guardxTokenInfo } = useToken({
    address: GUARDX,
  });

  const { data: andyxTokenInfo } = useToken({
    address: ANDYX,
  });

  const { data: potionPriceRate } = useCustomContractRead({
    Adrress: WETHX_PTN_MASTER_ORACLE_ADDRESS,
    Abi: WETHX_PTN_MASTER_ORACLE_ABI,
    FuncName: "getYTokenPrice",
    onSuccess: (data) => {},
  });

  let { data: AlienXPriceRate } = useCustomContractRead({
    Adrress: WETHX_PTN_MASTER_ORACLE_ADDRESS,
    Abi: WETHX_PTN_MASTER_ORACLE_ABI,
    FuncName: "getXTokenPrice",
    onSuccess: (data) => {},
  });

  AlienXPriceRate = new BigNumber(AlienXPriceRate)
    .div(AlienXPriceRate)
    .multipliedBy(1e18)
    .toNumber();
  // AlienXPriceRate = new BigNumber(AlienXPriceRate);
  // console.log("AlienXPriceRate", AlienXPriceRate, alienPrice);

  const { data: WethXTWAPRate } = useCustomContractRead({
    Adrress: WETHX_PTN_MASTER_ORACLE_ADDRESS,
    Abi: WETHX_PTN_MASTER_ORACLE_ABI,
    FuncName: "getXTokenTWAP",
    onSuccess: (data) => {},
  });
  // console.log("WethXTWAPRate", WethXTWAPRate);

  const { data: WethXLastUpdate } = useCustomContractRead({
    Adrress: WETHX_WETH_ORACLE_ADDRESS,
    Abi: WETHX_WETH_ORACLE_ABI,
    FuncName: "blockTimestampLast",
    onSuccess: (data) => {},
  });

  const { data: _lastRefreshCrTimestamp } = useCustomContractRead({
    Adrress: WETHX_PTN_POOL_ADDRESS,
    Abi: WETHX_PTN_POOL_ABI,
    FuncName: "lastRefreshCrTimestamp",
    onSuccess: (data) => {},
  });

  const { data: getAmountOutFoMinati } = useCustomContractRead({
    Adrress: SHLD_BNB_LP,
    Abi: IUniswapv2Pair,
    FuncName: "getReserves",
    onSuccess: (data) => {
      let _ptn = new BigNumber(data[1]);
      let _weth = new BigNumber(data[0]).multipliedBy(alienPrice);
      let _price = new BigNumber(_weth).div(_ptn);
      setPotionPrice(_price);
    },
  });

  useEffect(() => {
    if (getAmountOutFoMinati && alienPrice) {
      let _ptn = new BigNumber(getAmountOutFoMinati[1]);
      let _weth = new BigNumber(getAmountOutFoMinati[0]).multipliedBy(
        alienPrice
      );
      let _price = new BigNumber(_weth).div(_ptn);
      setPotionPrice(_price);
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [getAmountOutFoMinati, alienPrice]);

  // //console.log(getAmountOutFoMinati);

  useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "poolLength",
    onSuccess: (data) => {
      let arr = [];
      for (let i = 0; i < parseInt?.(data); i++) {
        arr.push(i);
      }
      //console.log(data);
      setPoolArray(arr);
    },
  });

  const { data: poolInfo } = useContractRead({
    address: WETHX_PTN_POOL_ADDRESS,
    abi: WETHX_PTN_POOL_ABI,
    functionName: "info",
  });
  // console.log("poolInfo", poolInfo);

  const { data: rewardPerSecond } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "rewardPerSecond",
    onSuccess: (data) => {},
  });

  //redirect
  const Stackhandler = () => {
    navigate("/Staking");
  };
  const Crosshandler = () => {
    navigate("/farm");
  };

  // const { data: poolLocked } = useBalance({
  //   addressOrName: WETHX_PTN_POOL_ADDRESS,
  //   token: WETH_TOKEN_ADDRESS,
  //   watch: true,
  // });

  const poolLocked = useBalance({
    address: WETHX_PTN_POOL_ADDRESS,
    token: WETH_TOKEN_ADDRESS,
    watch: true,
  });
  // console.log("poolLocked", poolLocked.data);

  // const { data: lpFarmBalanceTwo } = useBalance({
  //   addressOrName: POTION_DAO_CHEF_ADDRESS,
  //   token: BNBX_BNB_LP,
  //   watch: true,
  // });

  const { data: lpFarmBalance1 } = useBalance({
    address: POTION_DAO_CHEF_ADDRESS,
    token: BNBX_BNB_LP,
    watch: true,
    enabled: BNBX_BNB_LP !== undefined && POTION_DAO_CHEF_ADDRESS !== undefined,
  });

  const { data: lpFarmBalance2 } = useBalance({
    address: POTION_DAO_CHEF_ADDRESS,
    token: SHLD_BNB_LP,
    watch: true,
    enabled: SHLD_BNB_LP !== undefined && POTION_DAO_CHEF_ADDRESS !== undefined,
  });

  const { data: lpFarmBalance3 } = useBalance({
    address: POTION_DAO_CHEF_ADDRESS,
    token: GUARD_GUARDX_LP,
    watch: true,
    enabled:
      GUARD_GUARDX_LP !== undefined && POTION_DAO_CHEF_ADDRESS !== undefined,
  });

  const { data: lpFarmBalance4 } = useBalance({
    address: POTION_DAO_CHEF_ADDRESS,
    token: BNBX_GUARDX_LP,
    watch: true,
    enabled:
      BNBX_GUARDX_LP !== undefined && POTION_DAO_CHEF_ADDRESS !== undefined,
  });

  const { data: lpFarmBalance5 } = useBalance({
    address: POTION_DAO_CHEF_ADDRESS,
    token: ANDY_ANDYX_LP,
    watch: true,
    enabled:
      ANDY_ANDYX_LP !== undefined && POTION_DAO_CHEF_ADDRESS !== undefined,
  });

  // const { data: lpFarmBalanceOne } = useBalance({
  //   addressOrName: POTION_DAO_CHEF_ADDRESS,
  //   token: SHLD_BNB_LP,
  //   watch: true,
  //   enabled: SHLD_BNB_LP
  // });

  const lpFarmBalanceOne = useBalance({
    address: BNBX_BNB_LP,
    token: WETH_TOKEN_ADDRESS,
    watch: true,
  });

  const lpFarmBalanceTwo = useBalance({
    address: SHLD_BNB_LP,
    token: WETH_TOKEN_ADDRESS,
    watch: true,
  });

  const lpFarmBalanceThree = useBalance({
    address: GUARD_GUARDX_LP,
    token: GUARD,
    watch: true,
  });

  const lpFarmBalanceFour = useBalance({
    address: BNBX_GUARDX_LP,
    token: WETHX_TOKEN_ADDRESS,
    watch: true,
  });

  const lpFarmBalanceFive = useBalance({
    address: ANDY_ANDYX_LP,
    token: ANDY,
    watch: true,
  });

  const { data: _poolInfoOne } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    Args: [1],
    FuncName: "poolInfo",
    onSuccess: (data) => {},
  });
  const { data: _poolInfoTwo } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    Args: [0],
    FuncName: "poolInfo",
    onSuccess: (data) => {},
  });
  const { data: _totalAllocPOint } = useCustomContractRead({
    Adrress: POTION_DAO_CHEF_ADDRESS,
    Abi: POTION_DAO_CHEF_ABI,
    FuncName: "totalAllocPoint",
    onSuccess: (data) => {
      //console.log("_totalAllocPOint", data._totalAllocPOint);
    },
  });

  // const  = potionPrice;

  const { data: lpBalanceChef1 } = useBalance({
    address: BNBX_BNB_LP,
    token: WETH_TOKEN_ADDRESS,
    watch: true,
  });

  const { data: lpBalanceChef2 } = useBalance({
    address: SHLD_BNB_LP,
    token: WETH_TOKEN_ADDRESS,
    watch: true,
    enabled: SHLD_BNB_LP,
  });

  // console.log("lpBalanceChef2", lpBalanceChef2);

  const [lpRateOne, setLpRateOne] = useState(0);
  const [lpRateTwo, setlpRatetwo] = useState(0);
  const [lpRateThree, setlpRateThree] = useState(0);

  const { data: _lpRate1 } = useCustomContractRead({
    Adrress: BNBX_BNB_LP,
    Abi: TOKEN_ABI,
    FuncName: "totalSupply",
    isEnabled: alienPrice && lpBalanceChef1 ? true : false,
    onSuccess: (data) => {
      if (lpFarmBalanceOne.data) {
        const lpBalance = Number(lpFarmBalanceOne?.data?.value); // Ensure BigInt usage
        const totalSupply = Number(data); // Ensure BigInt usage
        const lpRate = (lpBalance * 2) / totalSupply; // Explicit conversion to Number
        setLpRateOne(lpRate);
      }
    },
  });
  useEffect(() => {
    if (_lpRate1 && lpFarmBalanceOne) {
      const lpBalance = Number(lpFarmBalanceOne?.data?.value); // Ensure BigInt usage
      const totalSupply = Number(_lpRate1); // Ensure BigInt usage
      const lpRate = (lpBalance * 2 * alienPrice) / totalSupply; // Explicit conversion to Number
      setLpRateOne(lpRate);
    }
  }, [_lpRate1, lpFarmBalanceOne, alienPrice]);

  const { data: _lpRate2 } = useCustomContractRead({
    Adrress: SHLD_BNB_LP,
    Abi: TOKEN_ABI,
    FuncName: "totalSupply",
    isEnabled: alienPrice && lpBalanceChef2 ? true : false,
    onSuccess: (data) => {
      if (lpFarmBalanceTwo.data) {
        const lpBalance = Number(lpFarmBalanceTwo?.data?.value); // Ensure BigInt usage
        const totalSupply = Number(data); // Ensure BigInt usage
        const lpRate = (lpBalance * 2) / totalSupply; // Explicit conversion to Number
        setlpRatetwo(lpRate);
      }
    },
  });
  useEffect(() => {
    if (_lpRate2 && lpFarmBalanceTwo) {
      const lpBalance = Number(lpFarmBalanceTwo?.data?.value); // Ensure BigInt usage
      const totalSupply = Number(_lpRate2); // Ensure BigInt usage
      const lpRate = (lpBalance * 2 * alienPrice) / totalSupply; // Explicit conversion to Number
      setlpRatetwo(lpRate);
    }
  }, [_lpRate2, lpFarmBalanceTwo, alienPrice]);

  const [guardPrice, setguardPrice] = useState(0);
  const { data: spotPrice } = useCustomContractRead({
    Adrress: BNB_GUARD_ORACLE,
    Abi: IUniswapOracle,
    FuncName: "spot",
    isEnabled: alienPrice !== undefined,
    Args: [GUARD, "1000000000000000000"],
    onSuccess: (data) => {
      setguardPrice(convertWeiToEther(spotPrice) * alienPrice);
    },
  });

  useEffect(() => {
    if (spotPrice && alienPrice) {
      setguardPrice(convertWeiToEther(spotPrice) * alienPrice);
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [spotPrice, alienPrice]);

  const [andyPrice, setandyPrice] = useState(0);
  const { data: spotPriceAndy } = useCustomContractRead({
    Adrress: ANDY_BNB_ORACLE,
    Abi: IUniswapOracleV3,
    FuncName: "quote",
    isEnabled: alienPrice !== undefined,
    Args: [ANDY, "1000000000000000000", WETH_TOKEN_ADDRESS],
    onSuccess: (data) => {
      setandyPrice(convertWeiToEther(spotPriceAndy) * alienPrice);
    },
  });

  useEffect(() => {
    if (spotPriceAndy && alienPrice) {
      setandyPrice(convertWeiToEther(spotPriceAndy) * alienPrice);
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [spotPriceAndy, alienPrice]);

  // useEffect(() => {

  //   // if (lpFarmBalanceOne) {
  //   //     const lpBalance = new BigNumber(lpFarmBalanceOne?.data?.formatted); // Ensure BigInt usage
  //   //   //  console.log("lpBalance", lpBalance, lpFarmBalanceOne?.data);

  //   //     const totalSupply = new BigNumber(_lpRate1).toNumber; // Ensure BigInt usage
  //   //     const lpRate = Number((lpBalance * 2n) / totalSupply); // Explicit conversion to Number
  //   //     setLpRateOne(lpRate);
  //   // }

  // }, [_lpRate1, lpFarmBalanceOne, alienPrice, lpBalanceChef])

  // console.log("lpBalance", new BigNumber(lpFarmBalanceOne.data.value).toNumber);

  // console.log("setlpRateOne", lpRateOne, lpRateTwo, lpBalanceChef2?.formatted);

  const PoolPair1 = ({
    rewardPerSecond,
    lpRate,
    lpFarmBalance,
    _poolInfo,
    _totalAllocPOint,
  }) => {
    const getApr = () => {
      // Convert and check rewardRate
      // console.log("PoolPair1", rewardPerSecond, lpRate, lpFarmBalance?.data?.formatted, _poolInfo, _totalAllocPOint);

      const rewardRate = rewardPerSecond
        ? convertWeiToEther(rewardPerSecond)
        : 0;

      // Calculate farmsRewardPerSecond, ensuring alloc points are valid
      const farmsRewardPerSecond =
        _poolInfo?.[0] && _totalAllocPOint
          ? (Number(_poolInfo[2]) / Number(_totalAllocPOint)) *
            Number(rewardRate)
          : 0;

      //console.log("farmsRewardPerSecond",  farmsRewardPerSecond);

      // Calculate annualFarmReward, ensuring farmsRewardPerSecond is valid
      const annualFarmReward = farmsRewardPerSecond * 86400 * 365;

      //console.log("annualFarmReward", annualFarmReward);

      // Calculate annualFarmRewardUSD, ensuring potionPrice is valid
      const annualFarmRewardUSD = potionPrice
        ? annualFarmReward * potionPrice
        : 0;
      //console.log("annualFarmRewardUSD", annualFarmRewardUSD);

      // Ensure lpFarmBalance and lpPrice are valid for TVL calculation
      const amount = lpFarmBalance?.formatted || 0;
      const totalValueLockedFarmUSD = amount * (lpRate || 0);

      //console.log("totalValueLockedFarmUSD",  totalValueLockedFarmUSD);

      // Calculate APR, ensuring totalValueLockedFarmUSD is not zero
      const APR = totalValueLockedFarmUSD
        ? parseFloat((annualFarmRewardUSD / totalValueLockedFarmUSD) * 100)
        : 0;

      return APR;
    };

    return <>{formatNumber(parseFloat(getApr()).toFixed(2))}%</>;
  };

  const PoolPair2 = ({
    rewardPerSecond,
    lpRate,
    lpFarmBalance,
    _poolInfo,
    _totalAllocPOint,
  }) => {
    const getApr = () => {
      // console.log("PoolPair2", rewardPerSecond, lpRate, lpFarmBalance?.data?.formatted, _poolInfo, _totalAllocPOint);

      // Convert and check rewardRate
      const rewardRate = rewardPerSecond
        ? convertWeiToEther(rewardPerSecond)
        : 0;

      // Calculate farmsRewardPerSecond, ensuring alloc points are valid
      const farmsRewardPerSecond =
        _poolInfo?.[2] && _totalAllocPOint
          ? (Number(_poolInfo[2]) / Number(_totalAllocPOint)) *
            Number(rewardRate)
          : 0;

      // console.log("farmsRewardPerSecond",  farmsRewardPerSecond);

      // Calculate annualFarmReward, ensuring farmsRewardPerSecond is valid
      const annualFarmReward = farmsRewardPerSecond * 86400 * 365;
      //console.log("annualFarmReward", annualFarmReward);

      // Calculate annualFarmRewardUSD, ensuring potionPrice is valid
      const annualFarmRewardUSD = Number(potionPrice)
        ? Number(annualFarmReward) * Number(potionPrice)
        : 4;
      //console.log("annualFarmRewardUSD", annualFarmRewardUSD);

      // Ensure lpFarmBalance and lpPrice are valid for TVL calculation
      const amount = lpFarmBalance?.formatted || 0;
      const totalValueLockedFarmUSD = Number(amount) * (Number(lpRate) || 0);
      // console.log("totalValueLockedFarmUSD",  totalValueLockedFarmUSD);

      // Calculate APR, ensuring totalValueLockedFarmUSD is not zero
      const APR = totalValueLockedFarmUSD
        ? parseFloat((annualFarmRewardUSD / totalValueLockedFarmUSD) * 100)
        : 0;

      //console.log("APR", APR);

      return APR;
    };

    return <>{formatNumber(parseFloat(getApr()).toFixed(2))}%</>;
  };

  // const lockedStaked = (parseFloat?.(convertWeiToEther?.(totalLockedValue)) * potionPrice)
  const totalStaked = Number(potionPrice)
    ? new BigNumber(totalSupply)
        .multipliedBy(potionPrice)
        .dividedBy(1e18)
        .toNumber()
    : 0;
  const totalLocked = Number(potionPrice)
    ? new BigNumber(totalLockedSupply)
        .multipliedBy(potionPrice)
        .dividedBy(1e18)
        .toNumber()
    : 0;

  const locekdP1 =
    lpFarmBalance1 && lpRateOne
      ? parseFloat?.(lpFarmBalance1?.formatted * lpRateOne)
      : 0;
  const locekdP2 =
    lpFarmBalance2 && lpRateTwo
      ? parseFloat?.(lpFarmBalance2?.formatted * lpRateTwo)
      : 0;

  const poolLockedValue =
    poolLocked && alienPrice
      ? parseFloat?.(poolLocked?.data?.formatted * alienPrice)
      : 0;
  const totalLockedValue = (
    totalStaked +
    totalLocked +
    locekdP1 +
    locekdP2 +
    poolLockedValue +
    60000
  ).toString();

  useEffect(() => {
    if (selectedToken === "BNBX" && bnbXPrice) {
      setSelectedTokenPrice(bnbXPrice);
      setSelectedTokenIcon("/icons/bnb.png");
    }
    if (selectedToken === "GUARDX" && guardPrice) {
      setSelectedTokenPrice(guardPrice);
      setSelectedTokenIcon("/icons/guard.png");
    }

    if (selectedToken === "ANDYX" && andyPrice) {
      setSelectedTokenPrice(andyPrice);
      setSelectedTokenIcon("/icons/andy.png");
    }
  }, [bnbXPrice, guardPrice, selectedToken, andyPrice]);

  // code for select new currency =============

  // const selectToken = (i) => {
  //   const token_arr = ["BNBX", "GUARDX"]
  //   const price = [bnbXPrice, guardPrice]

  //   setSelectedToken(token_arr[i])
  //   setSelectedTokenPrice(price[i])
  //   setTokenMenu(false)
  // }

  const tokenAssets = {
    BNBX: {
      icon: "/icons/bnb.png",
      address: WETHX_TOKEN_ADDRESS,
      tokenInfo: useToken({ address: WETHX_TOKEN_ADDRESS }).data,
      price: 0, // will be updated
      name: "BNBX",
    },
    GUARDX: {
      icon: "/icons/guard.png",
      address: GUARDX,
      tokenInfo: useToken({ address: GUARDX }).data,
      price: 0, // will be updated
      name: "GUARDX",
    },
    ANDYX: {
      icon: "/icons/andy.png",
      address: ANDYX,
      tokenInfo: useToken({ address: ANDYX }).data,
      price: 0, // will be updated
      name: "ANDYX",
    },
  };

  // Single state object for token management
  const [tokenState, setTokenState] = useState({
    selectedToken: "BNBX",
    tokenMenuOpen: false,
    tokens: tokenAssets,
  });

  // Get current token details
  const currentToken = tokenState.tokens[tokenState.selectedToken];

  // Update token price when data changes
  useEffect(() => {
    if (tokenState.selectedToken === "BNBX" && bnbXPrice) {
      updateTokenInfo("BNBX", { price: bnbXPrice });
    }
    if (tokenState.selectedToken === "GUARDX" && guardPrice) {
      updateTokenInfo("GUARDX", { price: guardPrice });
    }
    if (tokenState.selectedToken === "ANDYX" && andyPrice) {
      updateTokenInfo("ANDYX", { price: andyPrice });
    }
    if (alienxTokenInfo) {
      updateTokenInfo("BNBX", { tokenInfo: alienxTokenInfo });
    }
    if (guardxTokenInfo) {
      updateTokenInfo("GUARDX", { tokenInfo: guardxTokenInfo });
    }
    if (andyxTokenInfo) {
      updateTokenInfo("ANDYX", { tokenInfo: andyxTokenInfo });
    }
  }, [
    bnbXPrice,
    guardPrice,
    alienxTokenInfo,
    guardxTokenInfo,
    tokenState.selectedToken,
    andyPrice,
    andyxTokenInfo,
  ]);

  // Helper function to update token info
  const updateTokenInfo = (tokenSymbol, newInfo) => {
    setTokenState((prev) => ({
      ...prev,
      tokens: {
        ...prev.tokens,
        [tokenSymbol]: {
          ...prev.tokens[tokenSymbol],
          ...newInfo,
        },
      },
    }));
  };

  // Select a new token
  const selectToken = (tokenSymbol) => {
    setTokenState((prev) => ({
      ...prev,
      selectedToken: tokenSymbol,
      tokenMenuOpen: false,
    }));
    toggleTokenMenu();
  };

  // Toggle token menu
  const toggleTokenMenu = () => {
    setTokenState((prev) => ({
      ...prev,
      tokenMenuOpen: !prev.tokenMenuOpen,
    }));
  };

  // Calculate market cap for current token
  const getMarketCap = () => {
    if (!currentToken?.tokenInfo?.totalSupply?.formatted || !currentToken.price)
      return 0;
    return (
      parseFloat(currentToken.tokenInfo.totalSupply.formatted) *
      currentToken.price
    );
  };

  return (
    <>
      {/* <Navbar /> */}
      <main className={styles.main + " pb-5 pb-sm-0"}>
        <Hero locked={totalLockedValue} />
        <section
          className={
            styles.card_container + " container d-xl-flex gap-xxl-5 gap-3"
          }
        >
          <div className={styles.left}>
            <div className={styles.card + " position-relative"}>
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-2 align-items-center">
                  <div
                    className={
                      styles.imgdiv +
                      " d-flex justify-content-center align-items-center"
                    }
                  >
                    <img src="/icons/logo2.svg" alt="" />
                  </div>
                  <div>
                    <h2>SHiELD</h2>
                    <a
                      target="_blank"
                      href={`${EX_LINK}${PTN_TOKEN_ADDRESS}#code`}
                    >
                      View Contract
                    </a>
                  </div>
                </div>
                <div className={styles.price_parent + " text-end"}>
                  <p>
                    {" "}
                    <span className="me-2">Price</span>$
                    {Number(potionPrice).toFixed(3)}{" "}
                  </p>
                  {/* <p> <span className="me-2">Price</span>
                     TBA
                  </p> */}

                  {/* <p><span>${potionPrice}</span></p> */}
                  {/* <button className="btn3 py-1" onClick={() =>
                    addTokenInMetaMask(
                      minatiTokenInfo?.symbol,
                      PTN_TOKEN_ADDRESS,
                      ''
                    )
                  } > */}
                  <button className="btn3 py-1">
                    <AddIcon />
                    <img className="ms-2" src="/icons/metamask.svg" alt="" />
                  </button>
                </div>
              </div>

              {/* hellloo */}
              <div className="d-flex gap-2 flex-wrap flex-sm-nowrap justify-content-between mt-5">
                <div>
                  <span>Circulating supply</span>
                  <p className="text-start">
                    {formatNumber(
                      parseFloat?.(minatiTokenInfo?.totalSupply?.formatted) * 1
                    )}
                  </p>
                  {/* <p className="text-start">TBA</p> */}
                </div>
                <div>
                  <span>Market Cap</span>
                  <p className="text-start">
                    $
                    {formatNumber(
                      (
                        parseFloat?.(minatiTokenInfo?.totalSupply?.formatted) *
                        potionPrice
                      ).toFixed(2)
                    )}
                  </p>
                  {/* <p className="text-start">NA</p> */}
                </div>
                <a
                  className="btn1 py-2 px-4 py-3 d-flex justify-content-center align-items-center"
                  href={`https://pancakeswap.finance/swap?chain=bsc&inputCurrency=0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c&outputCurrency=0xD9E90DF21F4229249E8841580cDE7048bF935710`}
                  target="_blank"
                >
                  Buy SHiELD now
                </a>
              </div>
              {/* <div className={styles.btn_container+" d-flex justify-content-between gap-2  mt-3"}>
                <button onClick={() =>
                          addTokenInMetaMask(
                            minatiTokenInfo?.symbol,
                            PTN_TOKEN_ADDRESS,
                            ''
                          )
                        } >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                  </svg>
                  <img className="ms-2" src="/icons/metamask.svg" alt="" />
                </button>
                  <a className="btn1 py-2 px-4 py-3 d-flex justify-content-center align-items-center"
                    href={`https://pancakeswap.finance/swap?chain=bscTestnet&inputCurrency=0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c&outputCurrency=0xD9E90DF21F4229249E8841580cDE7048bF935710`}
                    target="_blank"
                  >Buy SHLD now</a>
              </div> */}
              <div
                className={
                  styles.row2 +
                  " d-flex flex-column align-items-center flex-sm-row gap-xxl-5 gap-sm-3 my-3 justify-content-between"
                }
              >
                <div className="d-flex justify-content-between justify-content-start gap-3 pb-sm-3 pb-0">
                  <div className="d-flex position-relative justify-content-between ">
                    <div>
                      <span>Stake APR</span>
                      <p className="text-start">
                        {formatNumber(parseFloat(getApr()).toFixed(2) || 0)}%
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <span>Lock APR</span>
                      <p className="text-start">
                        {formatNumber(
                          parseFloat(getLockerApr()).toFixed(2) || 0
                        )}
                        %
                      </p>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-2 justify-content-between justify-content-sm-end">
                  <Link className="btn1 py-3 px-4" to="/stake">
                    Stake
                  </Link>
                  <Link className="btn1 py-3 px-4" to="/lock">
                    Lock
                  </Link>
                </div>
              </div>
              <div
                className={
                  styles.row3 +
                  " d-flex flex-wrap flex-sm-wrap gap-2 px-3 justify-content-between align-items-center"
                }
              >
                <div className="d-flex align-items-end gap-4">
                  <span>Collateral Ratio</span>
                  <p className="text-nowrap">
                    {parseInt?.(poolInfo?.[0]) / 10e3} %
                  </p>
                </div>
                <p>
                  Last Update:{" "}
                  {_lastRefreshCrTimestamp
                    ? new Date(
                        Number(_lastRefreshCrTimestamp) * 1e3
                      ).toLocaleString()
                    : "NA"}
                </p>
              </div>
            </div>
          </div>

          {/* next section */}
          <div className={styles.right}>
            <div className={styles.card}>
              <div className="d-flex justify-content-between">
                <div
                  className={
                    styles.coinDroper + " d-flex gap-2 align-items-center"
                  }
                  onClick={toggleTokenMenu}
                >
                  <div
                    className={
                      styles.imgdiv1 +
                      " d-flex justify-content-center align-items-center"
                    }
                  >
                    <img src={currentToken.icon} alt="" />
                  </div>
                  <div>
                    <h2>{currentToken.name}</h2>
                    <a
                      href={`${EX_LINK}${currentToken.address}#code`}
                      onClick={(e) => e.stopPropagation()}
                      target="_blank"
                    >
                      View Contract
                    </a>
                  </div>
                  <button
                    style={{
                      top: "20%",
                      right: "20px",
                      scale: !tokenState.tokenMenuOpen ? "1 -1" : "1 1",
                    }}
                    className="position-absolute border-0 bg-transparent"
                  >
                    <svg
                      width="17"
                      height="12"
                      viewBox="0 0 17 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.93359 9.75756L8.74201 2.44482L14.9092 9.75757"
                        stroke="black"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <div
                    className={`${styles.droper} ${
                      tokenState.tokenMenuOpen ? "d-block" : "d-none"
                    }`}
                  >
                    {Object.entries(tokenState.tokens).map(
                      ([symbol, token]) => (
                        <div
                          key={symbol}
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => selectToken(symbol)}
                        >
                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={token.icon}
                              className="rounded-circle bg-black p-2"
                              width="42px"
                              alt=""
                            />
                            <h3>{symbol}</h3>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
                <div className={styles.price_parent + " text-end"}>
                  <p>
                    <span className="me-2">Price</span>$
                    {currentToken.price?.toFixed(2) || "0.00"}
                  </p>
                  <button
                    className="btn3 py-1"
                    onClick={() =>
                      addTokenInMetaMask(
                        currentToken.tokenInfo?.symbol,
                        currentToken.address,
                        ""
                      )
                    }
                  >
                    <AddIcon />
                    <img className="ms-2" src="/icons/metamask.svg" alt="" />
                  </button>
                </div>
              </div>

              <div className="d-flex gap-2 gap-lg-0 flex-wrap -nowrap justify-content-between mt-4">
                <div>
                  <span>Circulating supply</span>
                  <p className="text-start">
                    {formatNumber(
                      parseFloat(
                        currentToken.tokenInfo?.totalSupply?.formatted || "0"
                      ).toFixed(2)
                    )}
                  </p>
                </div>
                <div>
                  <span>Market Cap</span>
                  <p className="text-start">
                    ${formatNumber(getMarketCap().toFixed(2))}
                  </p>
                </div>
                <div
                  className={
                    styles.btndiv1 +
                    " d-flex justify-content-between justify-content-md-end gap-2"
                  }
                >
                  <Link
                    to="/mint"
                    className="btn1 px-3 py-3 text-decoration-none d-flex justify-content-center align-items-center"
                  >
                    Mint
                  </Link>
                  <Link
                    to={`https://pancakeswap.finance/swap?outputCurrency=${currentToken.address}&chain=bsc`}
                    target="_blank"
                    className="btn1 text-decoration-none px-xxl-4 px-xl-3 px-2 py-2 d-flex justify-content-center align-items-center"
                  >
                    Buy {currentToken.name} now
                  </Link>
                </div>
              </div>

              {/* <div className={styles.btn_container + " d-flex justify-content-between gap-2  mt-3"}>
                <button onClick={() =>
                  addTokenInMetaMask(
                    alienxTokenInfo?.symbol,
                    WETHX_TOKEN_ADDRESS,
                    ''
                  )
                }>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                  </svg>
                  <img className="ms-2" src="/icons/metamask.svg" alt="" />
                </button>
                <div className={" d-flex gap-2"}>
                  <Link to="/mint" className="btn1 px-3 py-3 text-decoration-none d-flex justify-content-center align-items-center">Mint</Link>
                  <Link to="https://pancakeswap.finance/swap?outputCurrency=0xcF4a682545FaBE24551101820022fF66A016207d&chain=bscTestnet" target="_blank" className="btn1 text-decoration-none px-xxl-4 px-xl-3 px-2 py-2 d-flex justify-content-center align-items-center">Buy WETH now</Link>
                </div>
              </div> */}
              <div
                className={
                  styles.row2 +
                  " d-flex flex-column flex-sm-row gap-xxl-5 gap-3 my-3 justify-content-between"
                }
              >
                <div className="d-flex justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <div className={styles.imgdiv + " d-flex"}>
                      <div className="d-flex justify-content-center align-items-center p-sm-2 p-1">
                        <img src="/icons/logo2.svg" alt="" />
                      </div>
                      <div className="d-flex justify-content-center align-items-center p-sm-2 p-1">
                        <img src="/icons/bnb.png" alt="" />
                      </div>
                    </div>
                    <div>
                      <p className="text-start fs-6">SHiELD/</p>
                      <p className="text-start fs-6">BNB</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <span>APR</span>
                    <p>
                      <PoolPair2
                        lpFarmBalance={lpFarmBalance2}
                        _poolInfo={_poolInfoTwo}
                        _totalAllocPOint={_totalAllocPOint}
                        lpRate={lpRateTwo}
                        rewardPerSecond={rewardPerSecond}
                      />
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <div className={styles.imgdiv + " d-flex"}>
                      <div className="d-flex justify-content-center align-items-center p-2">
                        <img src="/icons/bnb.png" alt="" />
                      </div>
                      <div className="d-flex justify-content-center align-items-center p-2">
                        <img src="/icons/bnb.png" alt="" />
                      </div>
                    </div>
                    <div>
                      <p className="text-start fs-6">BNBX/</p>
                      <p className="text-start fs-6">BNB</p>
                    </div>
                  </div>
                  <div className="text-end">
                    <span>APR</span>

                    <p>
                      <PoolPair1
                        lpFarmBalance={lpFarmBalance1}
                        _poolInfo={_poolInfoOne}
                        _totalAllocPOint={_totalAllocPOint}
                        lpRate={lpRateOne}
                        rewardPerSecond={rewardPerSecond}
                      />
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={
                  styles.row3 +
                  "  d-flex flex-wrap flex-sm-nowrap gap-2 justify-content-between align-items-end px-3"
                }
              >
                <div className="d-flex align-items-end gap-3">
                  <span>60-MIN TWAP</span>
                  <p className="mb-0">
                    {parseFloat?.(convertWeiToEther?.(WethXTWAPRate)).toFixed(
                      2
                    )}{" "}
                    BNB
                  </p>
                </div>
                <p className="mb-0">
                  Last Update:{" "}
                  {WethXLastUpdate
                    ? new Date(WethXLastUpdate * 1e3).toLocaleString()
                    : "NA"}
                </p>
              </div>
            </div>
            {/* <div className={styles.row2 + " d-flex flex-column flex-sm-row gap-xxl-5 gap-3 my-5 justify-content-between"}>
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <div className={styles.imgdiv + " d-flex"}>
                    <div className="d-flex justify-content-center align-items-center p-sm-2 p-1">
                      <img src="/icons/logo2.svg" alt="" />
                    </div>
                    <div className="d-flex justify-content-center align-items-center p-sm-2 p-1">
                      <img src="/icons/bnb.png" alt="" />
                    </div>
                  </div>
                  <div>
                    <p className="text-start fs-6">SHLD/</p>
                    <p className="text-start fs-6">WBNB</p>
                  </div>
                </div>
                <div>
                  <span>APR</span>
                  <p>
                    <PoolPair1 lpFarmBalance={lpFarmBalanceOne} _poolInfo={_poolInfoOne} _totalAllocPOint={_totalAllocPOint} lpRate={lpRateOne} rewardPerSecond={rewardPerSecond} />
                  </p>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <div className={styles.imgdiv + " d-flex"}>
                    <div className="d-flex justify-content-center align-items-center p-2">
                      <img src="/icons/bnb.png" alt="" />
                    </div>
                    <div className="d-flex justify-content-center align-items-center p-2">
                      <img src="/icons/bnb.png" alt="" />
                    </div>
                  </div>
                  <div>
                    <p className="text-start fs-6">WBNBX/</p>
                    <p className="text-start fs-6">WBNB</p>
                  </div>
                </div>
                <div>
                  <span>APR</span>
                  <p>
                    <PoolPair2 lpFarmBalance={lpFarmBalanceTwo} _poolInfo={_poolInfoTwo} _totalAllocPOint={_totalAllocPOint} lpRate={lpRateTwo} rewardPerSecond={rewardPerSecond} />
                  </p>
                </div>
              </div>
            </div> */}
            {/* <div className={styles.row3 + " d-flex gap-3 justify-content-between align-items-center"}>
              <div className="d-flex gap-3">
                <span>WETH 60-MIN TWAP</span>
                <p className="fs-sm-5 fs-6">
                  {parseFloat?.(
                    convertWeiToEther?.(WethXTWAPRate)
                  ).toFixed(2)}{" "}
                  WETH
                </p>
              </div>
              <p>
                Last Update: {WethXLastUpdate ? new Date(WethXLastUpdate * 1e3).toLocaleString() : "NA"}
              </p>
            </div> */}
          </div>
        </section>
        <NewFooter />
      </main>
    </>
  );
}
